// Single source of truth for 75 MW grid capacity tier classification.
// Used by: map layer (via API SQL CASE), briefing finding, substation detail panel.
// If thresholds change, update here AND in api-server/routes/power.js SQL CASE.

export type CapacityTier = 'high' | 'likely' | 'moderate' | 'low';

export function computeCapacityTier(voltageKv: number | null, lines: number | null): CapacityTier | null {
  if (voltageKv == null) return null;
  const l = lines ?? 0;
  if (voltageKv >= 345 && l >= 3) return 'high';
  if (voltageKv >= 345) return 'likely';
  if (voltageKv >= 230 && l >= 2) return 'likely';
  if (voltageKv >= 138 && l >= 4) return 'moderate';
  if (voltageKv >= 138 && l >= 2) return 'low';
  return null;
}

export const CAPACITY_TIER_CONFIG: Record<CapacityTier, { label: string; color: string; description: string }> = {
  high: {
    label: 'High Confidence',
    color: '#16a34a',
    description: '345+ kV with 3+ transmission lines. Standard 345 kV transformers are rated 500\u20131,000 MVA \u2014 well above 75 MW.',
  },
  likely: {
    label: 'Likely',
    color: '#0891b2',
    description: '345+ kV (any line count) or 230+ kV with 2+ lines. These substations typically have transformers rated 100\u2013500 MVA.',
  },
  moderate: {
    label: 'Moderate',
    color: '#d97706',
    description: '138 kV with 4+ transmission lines. High redundancy suggests a hub substation, but 138 kV transformer ratings vary widely (50\u2013300 MVA).',
  },
  low: {
    label: 'Low Confidence',
    color: '#6A7E8E',
    description: '138 kV with 2\u20133 lines. May be a rural feeder or tap station. Transformer capacity could be below 75 MVA.',
  },
};
